import styled from 'styled-components';

export const ButtonsGroup = styled.div`
  display: flex;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 1rem;
  }
`;
